export default {
  name: 'ReviewsPagination',
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      visiblePages: 3,
      perList: 3
    }
  },
  computed: {
    startPage() {
      let start = this.currentPage - 1;

      if (start < 1) {
        start = 1;
      }

      if (start + this.perList - 1 > this.limit) {
        start = Math.max(1, this.limit - this.perList + 1);
      }

      return start;
    },
    endPage() {
      return Math.min(this.startPage + this.perList - 1, this.limit);
    },
    visiblePageNumbers() {
      const pages = [];
      for (let i = this.startPage; i <= this.endPage; i++) {
        pages.push(i);
      }
      return pages;
    },
    hasPrevBlock() {
      return this.currentPage > 1;
    },
    hasNextBlock() {
      return this.currentPage < this.limit;
    }
  },
  methods: {
    handleChangePage(page) {
      if (page >= 1 && page <= this.limit) {
        this.$emit('change-page', page);
      }
    },
    goToPrevBlock() {
      if (this.hasPrevBlock) {
        this.handleChangePage(this.currentPage - 1);
      }
    },
    goToNextBlock() {
      if (this.hasNextBlock) {
        this.handleChangePage(this.currentPage + 1);
      }
    }
  }
}
